// extracted by mini-css-extract-plugin
export var active = "teachers-and-coaches-module--active--de58e";
export var carouselLeftButtonWrapper = "teachers-and-coaches-module--carouselLeftButtonWrapper--1e62a";
export var carouselRightButtonWrapper = "teachers-and-coaches-module--carouselRightButtonWrapper--277fe";
export var carouselWrapper = "teachers-and-coaches-module--carousel-wrapper--8718c";
export var chevronIcon = "teachers-and-coaches-module--chevronIcon--14fcb";
export var image = "teachers-and-coaches-module--image--58341";
export var imageCaption = "teachers-and-coaches-module--image-caption--9cff2";
export var imageWrapper = "teachers-and-coaches-module--image-wrapper--56ce7";
export var indicator = "teachers-and-coaches-module--indicator--57cdc";
export var leftContent = "teachers-and-coaches-module--leftContent--d5e38";
export var paddingText = "teachers-and-coaches-module--paddingText--f46ce";
export var quote = "teachers-and-coaches-module--quote--7f4ac";
export var quoteMarks = "teachers-and-coaches-module--quoteMarks--e1e01";
export var root = "teachers-and-coaches-module--root--b6d1f";
export var slider = "teachers-and-coaches-module--slider--e25b4";
export var teacherHolder = "teachers-and-coaches-module--teacherHolder--55c41";
export var teacherImage = "teachers-and-coaches-module--teacherImage--98b22";
export var teacherNamePopup = "teachers-and-coaches-module--teacherNamePopup--aa0dc";
export var teachers = "teachers-and-coaches-module--teachers--3766e";
export var teachersCard = "teachers-and-coaches-module--teachersCard--c881c";